import { Component } from '@angular/core';

@Component({
  selector: 'hd-left-side',
  templateUrl: './left-side.component.html',
  styleUrls: ['./left-side.component.scss']
})
export class LeftSideComponent {
}
